export default "__VITE_ASSET__dec72f11__"